export const FETCH_USER_SUBSCRIPTION_PLANS_START =
  'FETCH_USER_SUBSCRIPTION_PLANS_START';
export const FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS';
export const FETCH_USER_SUBSCRIPTION_PLANS_FAILURE =
  'FETCH_USER_SUBSCRIPTION_PLANS_FAILURE';

export const CANCEL_USER_SUBSCRIPTION_PLAN_START =
  'CANCEL_USER_SUBSCRIPTION_PLAN_START';
export const CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS =
  'CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS';
export const CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE =
  'CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE';

export const FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_START =
  'FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_START';
export const FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_SUCCESS';
export const FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_FAILURE =
  'FETCH_USER_SUBSCRIPTION_BILLING_CYCLE_USAGE_FAILURE';

export const FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_START =
  'FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_START';
export const FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_SUCCESS';
export const FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_FAILURE =
  'FETCH_USER_SUBSCRIPTION_MONTHLY_USAGE_FAILURE';

export const FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_START =
  'FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_START';
export const FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_SUCCESS';
export const FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_FAILURE =
  'FETCH_USER_SUBSCRIPTION_EDUCATOR_SEATS_FAILURE';

export const FETCH_OWNER_AND_ADMINS_START = 'FETCH_OWNER_AND_ADMINS_START';
export const FETCH_OWNER_AND_ADMINS_SUCCESS = 'FETCH_OWNER_AND_ADMINS_SUCCESS';
export const FETCH_OWNER_AND_ADMINS_FAILURE = 'FETCH_OWNER_AND_ADMINS_FAILURE';

export const FETCH_LINKED_COURSE_PATHS = 'FETCH_LINKED_COURSE_PATHS';
export const FETCH_LINKED_COURSE_PATHS_SUCCESS =
  'FETCH_LINKED_COURSE_PATHS_SUCCESS';

export const INVITE_USER_TO_SUBSCRIPTION = 'INVITE_USER_TO_SUBSCRIPTION';
export const INVITE_USER_TO_SUBSCRIPTION_SUCCESS =
  'INVITE_USER_TO_SUBSCRIPTION_SUCCESS';

export const FETCH_PAYMENT_METHOD_SUMMARY = 'FETCH_PAYMENT_METHOD_SUMMARY';
export const FETCH_PAYMENT_METHOD_SUMMARY_SUCCESS =
  'FETCH_PAYMENT_METHOD_SUMMARY_SUCCESS';

export const REVOKE_USER_ACCESS_TO_SUBSCRIPTION =
  'REVOKE_USER_ACCESS_TO_SUBSCRIPTION';
export const REVOKE_USER_ACCESS_TO_SUBSCRIPTION_SUCCESS =
  'REVOKE_USER_ACCESS_TO_SUBSCRIPTION_SUCCESS';

export const FETCH_USER_SUBSCRIPTION_PLAN_DATA =
  'FETCH_USER_SUBSCRIPTION_PLAN_DATA';
export const FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_PLAN_DATA_SUCCESS';

export const FETCH_MONTHLY_USAGE_SUMMARY_START =
  'FETCH_MONTHLY_USAGE_SUMMARY_START';
export const FETCH_MONTHLY_USAGE_SUMMARY = 'FETCH_MONTHLY_USAGE_SUMMARY';
export const FETCH_MONTHLY_USAGE_SUMMARY_FAILURE =
  'FETCH_MONTHLY_USAGE_SUMMARY_FAILURE';

export const SET_CURRENT_SELECTED_USER_SUBSCRIPTION =
  'SET_CURRENT_SELECTED_USER_SUBSCRIPTION';

export const REDIRECT_TO_SOLUTIONS_PAGE = 'REDIRECT_TO_SOLUTIONS_PAGE';

export const ADD_ADMIN_TO_INSTITUTION = 'ADD_ADMIN_TO_INSTITUTION';
export const ADD_ADMIN_TO_INSTITUTION_SUCCESS =
  'ADD_ADMIN_TO_INSTITUTION_SUCCESS';
export const ADD_ADMIN_TO_INSTITUTION_FAILURE =
  'ADD_ADMIN_TO_INSTITUTION_FAILURE';

export const SETUP_CURRENT_SELECTED_PLAN = 'SETUP_CURRENT_SELECTED_PLAN';

export const LIST_INSTITUTIONS_UNDER_PLAN = 'LIST_INSTITUTIONS_UNDER_PLAN';
export const LIST_INSTITUTIONS_UNDER_PLAN_SUCCESS =
  'LIST_INSTITUTIONS_UNDER_PLAN_SUCCESS';
export const LIST_INSTITUTIONS_UNDER_PLAN_FAILURE =
  'LIST_INSTITUTIONS_UNDER_PLAN_FAILURE';

export const GET_STRIPE_CONNECT_LINK = 'GET_STRIPE_CONNECT_LINK';
export const GET_STRIPE_CONNECT_LINK_ERROR = 'GET_STRIPE_CONNECT_LINK_ERROR';

export const SET_UP_STRIPE_CONNECT = 'SET_UP_STRIPE_CONNECT';
export const SET_UP_STRIPE_CONNECT_ERROR = 'SET_UP_STRIPE_CONNECT_ERROR';

export const REDIRECT_TO_STRIPE_CONNECT_PAGE =
  'REDIRECT_TO_STRIPE_CONNECT_PAGE';

export const FETCH_PAYMENT_TRANSACTIONS = 'FETCH_PAYMENT_TRANSACTIONS';
export const FETCH_PAYMENT_TRANSACTIONS_SUCCESS =
  'FETCH_PAYMENT_TRANSACTIONS_SUCCESS';
export const FETCH_PAYMENT_TRANSACTIONS_ERROR =
  'FETCH_PAYMENT_TRANSACTIONS_ERROR';
